export default "__VITE_ASSET__PJUW6yyl__"